import { EmissaoCupomFiscalActionsTypes } from "./emissaoCupomFiscalActions"
import type { EmissaoCupomFiscalAction } from "./emissaoCupomFiscalActions"
import { EmissaoCupomFiscalInicial } from "../models/emissaoCupomFiscalModel"
import type { EmissaoCupomFiscalModel } from "../models/emissaoCupomFiscalModel"

export function emissaoCupomFiscalReducer(
    state: EmissaoCupomFiscalModel,
    action: EmissaoCupomFiscalAction
): EmissaoCupomFiscalModel {
    const { CARREGAR, SET_FILTRO } = EmissaoCupomFiscalActionsTypes

    switch (action.type) {
        case CARREGAR:
            return { ...state, cupons: action.payload }

        case SET_FILTRO:
            return { ...state, filtros: { ...state.filtros, ...action.payload } }

        default:
            return state
    }
}

export { EmissaoCupomFiscalInicial }
